/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {activityBulkSearch} from '../api'

export const useMutationActivityBulkSearch = createReactQueryMutationHook('activityBulkSearch', activityBulkSearch)
